// src/components/tiles/WorkflowStepTile.jsx
import React from 'react';
import TileShell from './TileShell';
import ScoreBadge from './ScoreBadge';
import ReceiptsList from './ReceiptsList';

export default function WorkflowStepTile({
  // stage,            // ⬅️ no longer shown
  jtbdStepName,
  title,
  description,
  // count,            // ⬅️ no interviews pill here anymore
  satisfaction,
  satisfactionJustification,
  receipts
}) {
  const metricsRow = (
    <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
      <ScoreBadge label="Satisfaction" value={satisfaction} metricKey="satisfaction" />
    </div>
  );

  const body = description ? (
    <div style={{ fontSize: 13, color: 'var(--mui-palette-text-secondary)' }}>
      <strong>How they do it:</strong> {description}
    </div>
  ) : null;

  return (
    <TileShell
      typePill="workflow"
      title={`${title}`}
      subtitle={jtbdStepName ? `JTBD step: ${jtbdStepName}` : undefined}
      justification={satisfactionJustification}
      metricsRow={metricsRow}
      body={body}
      receipts={<ReceiptsList receipts={receipts || []} />}
    />
  );
}
